import { render, staticRenderFns } from "./BrandAndTitle.vue?vue&type=template&id=f70e4d64"
import script from "./BrandAndTitle.vue?vue&type=script&lang=js"
export * from "./BrandAndTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports